module.exports = __webpack_public_path__ + "media/images/iphone-screen-a498facf87c52ecc95c916d28438d3dd.jpg";